import { render } from "./ConfigurationView.vue?vue&type=template&id=33bf3a4e&scoped=true"
import script from "./ConfigurationView.vue?vue&type=script&lang=js"
export * from "./ConfigurationView.vue?vue&type=script&lang=js"

import "@/assets/css/ConfigurationView.css?vue&type=style&index=0&id=33bf3a4e&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33bf3a4e"]])

export default __exports__